class InceptionHeaderController {
  constructor(EventEmitter) {
    'ngInject';
    this.eventEmitter = EventEmitter;
    this.isInception = true;
  }

  isMyVacationsMobile() {
    return this.view === this.views.myVacationsMobile;
  }

  isPeriodListMobile() {
    return this.view === this.views.periodListMobile;
  }

  onMyVacationsMobile() {
    this.onChangeView(this.eventEmitter({view: this.views.myVacationsMobile}));
  }

  onPeriodListMobile() {
    this.onChangeView(this.eventEmitter({view: this.views.periodListMobile}));
  }
}

export default InceptionHeaderController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/managerAsEmployeeCalendarMobile/inceptionHeader/inceptionHeader.controller.js